import { render, staticRenderFns } from "./CreateIdeasoftChannel.vue?vue&type=template&id=1a386324&scoped=true"
import script from "./CreateIdeasoftChannel.vue?vue&type=script&lang=js"
export * from "./CreateIdeasoftChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateIdeasoftChannel.vue?vue&type=style&index=0&id=1a386324&prod&lang=scss&scoped=true"
import style1 from "./CreateIdeasoftChannel.vue?vue&type=style&index=1&id=1a386324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a386324",
  null
  
)

export default component.exports